import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3568f53e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "question-content mt-2" }

import {
	CompanyAssessmentQuestionType,
	type CompanyAssessmentQuestionAnswerDto,
	type CompanyAssessmentQuestionDto,
} from "@/dto";
import { computed, nextTick, ref, watch } from "vue";
import type { PropType } from "vue";
import { cloneDeep } from "lodash";
import { getTranslation } from "./companyAssessmentShared";
import CompanyAssessmentFormDate from "./Inputs/CompanyAssessmentFormDate.vue";
import CompanyAssessmentFormDecimal from "./Inputs/CompanyAssessmentFormDecimal.vue";
import CompanyAssessmentFormMultiSelect from "./Inputs/CompanyAssessmentFormMultiSelect.vue";
import CompanyAssessmentFormNumber from "./Inputs/CompanyAssessmentFormNumber.vue";
import CompanyAssessmentFormSelect from "./Inputs/CompanyAssessmentFormSelect.vue";
import CompanyAssessmentFormText from "./Inputs/CompanyAssessmentFormText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyAssessmentPulseQuestion',
  props: {
	question: {
		type: Object as PropType<CompanyAssessmentQuestionDto>,
		required: true,
	},

	questionAnswer: {
		type: Object as PropType<CompanyAssessmentQuestionAnswerDto>,
		required: true,
	},

	language: {
		type: String,
		required: true,
	},

	isOdd: {
		type: Boolean,
		default: false,
	},
},
  emits: ["update:question-answer"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const localAnswer = ref<CompanyAssessmentQuestionAnswerDto>(cloneDeep(props.questionAnswer));
const isUpdatingFromParent = ref(false);

watch(
	() => props.questionAnswer,
	(newValue) => {
		isUpdatingFromParent.value = true;
		localAnswer.value = cloneDeep(newValue);
		nextTick(() => {
			isUpdatingFromParent.value = false;
		});
	},
	{ deep: true }
);

watch(
	localAnswer,
	(newValue, oldValue) => {
		if (oldValue == null || isUpdatingFromParent.value) return;
		emit("update:question-answer", newValue);
	},
	{ deep: true }
);

const questionType = computed(() => props.question.questionType);

const isTextType = computed(() => {
	return (
		questionType.value === CompanyAssessmentQuestionType.Text ||
		questionType.value === CompanyAssessmentQuestionType.TextArea
	);
});

const label = computed(() => {
	return getTranslation(
		props.question,
		props.language,
		(question) => question.translations,
		(translation) => translation.title
	);
});

const myId = computed(() => `company-assessment-pulse-question-${props.question.id}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["company-assessment-pulse-question", { 'is-odd': __props.isOdd }])
  }, [
    _createElementVNode("div", {
      class: "question-title",
      id: myId.value
    }, _toDisplayString(label.value), 9, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      (isTextType.value)
        ? (_openBlock(), _createBlock(CompanyAssessmentFormText, {
            key: 0,
            id: myId.value,
            question: __props.question,
            language: __props.language,
            modelValue: localAnswer.value.answerText,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localAnswer.value.answerText) = $event))
          }, null, 8, ["id", "question", "language", "modelValue"]))
        : (questionType.value === _unref(CompanyAssessmentQuestionType).Select)
          ? (_openBlock(), _createBlock(CompanyAssessmentFormSelect, {
              key: 1,
              id: myId.value,
              question: __props.question,
              language: __props.language,
              modelValue: localAnswer.value.choiceId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localAnswer.value.choiceId) = $event))
            }, null, 8, ["id", "question", "language", "modelValue"]))
          : (questionType.value === _unref(CompanyAssessmentQuestionType).MultiSelect)
            ? (_openBlock(), _createBlock(CompanyAssessmentFormMultiSelect, {
                key: 2,
                id: myId.value,
                question: __props.question,
                language: __props.language,
                modelValue: localAnswer.value.multipleChoices,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localAnswer.value.multipleChoices) = $event))
              }, null, 8, ["id", "question", "language", "modelValue"]))
            : (questionType.value === _unref(CompanyAssessmentQuestionType).Number)
              ? (_openBlock(), _createBlock(CompanyAssessmentFormNumber, {
                  key: 3,
                  id: myId.value,
                  question: __props.question,
                  language: __props.language,
                  modelValue: localAnswer.value.answerInt,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localAnswer.value.answerInt) = $event))
                }, null, 8, ["id", "question", "language", "modelValue"]))
              : (questionType.value === _unref(CompanyAssessmentQuestionType).Decimal)
                ? (_openBlock(), _createBlock(CompanyAssessmentFormDecimal, {
                    key: 4,
                    id: myId.value,
                    question: __props.question,
                    language: __props.language,
                    modelValue: localAnswer.value.answerDecimal,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localAnswer.value.answerDecimal) = $event))
                  }, null, 8, ["id", "question", "language", "modelValue"]))
                : (questionType.value === _unref(CompanyAssessmentQuestionType).Date)
                  ? (_openBlock(), _createBlock(CompanyAssessmentFormDate, {
                      key: 5,
                      id: myId.value,
                      question: __props.question,
                      language: __props.language,
                      modelValue: localAnswer.value.answerDate,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((localAnswer.value.answerDate) = $event))
                    }, null, 8, ["id", "question", "language", "modelValue"]))
                  : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})